module.exports = {
      id: "icon-booking-dialysis-usage",
      viewBox: "0 0 24 24",
      url: __webpack_public_path__ + "../resources/views/web/layout/partials/svg-icons.blade.php#icon-booking-dialysis",
      toString: function () {
        return this.url;
      }
    }